export const DATES_AT_A_GLANCE_TIMELINE_SERIES = [
  {
    dataKey: 'completedMilestones',
    fill: '#03ffd2',
    name: 'Completed',
  },
  {
    dataKey: 'overdueMilestones',
    fill: '#f64d4f',
    name: 'Overdue',
  },
  {
    dataKey: 'upcomingMilestones',
    fill: '#f2c94c',
    name: 'Upcoming',
  },
  {
    dataKey: 'scheduledMilestones',
    fill: '#949494',
    name: 'Scheduled',
  },
] as const;

export type DatesAtAGlanceTimelineDataKey =
  (typeof DATES_AT_A_GLANCE_TIMELINE_SERIES)[number]['dataKey'];

export type DatesAtAGlanceMilestoneStatus =
  | 'completed'
  | 'overdue'
  | 'upcoming'
  | 'scheduled';

export const DATES_AT_A_GLANCE_MILESTONE_STATUS_LABELS: Record<
  DatesAtAGlanceMilestoneStatus,
  string
> = {
  completed: 'Completed',
  overdue: 'Overdue',
  scheduled: 'Scheduled',
  upcoming: 'Upcoming',
};
